import { CoreEnums } from '@/utils/domain/constants';

export const MODEL_NAME = 'whiteLabel';

/**
 * Screen follows GET /me/navigation.isAutomyOwner. The route allows
 * owner and super-admin; the page redirects when that flag is absent.
 * Entity WhiteLabel (`PermissionEntity = 56`) Read/Write is enforced by the API.
 * The client has no entity ACL: `canEdit` is the owner session and is applied
 * only after GET local succeeds. A 403 still clears `canEdit`.
 */
export const FETCH_ERROR = {
  FORBIDDEN: 'forbidden',
  LOAD_FAILED: 'loadFailed',
};

export const ROUTES = {
  LOCAL: 'company/white-label',
  EFFECTIVE: 'company/white-label/effective',
  ASSET_REQUIREMENTS: 'company/white-label/asset-requirements',
  CUSTOM_DOMAIN: 'company/white-label/custom-domain',
  CUSTOM_DOMAIN_VERIFY: 'company/white-label/custom-domain/verify',
  CUSTOM_DOMAIN_ACTIVATE: 'company/white-label/custom-domain/activate',
  CUSTOM_DOMAIN_DISABLE: 'company/white-label/custom-domain/disable',
};

export const WhiteLabelSource = CoreEnums.WhiteLabelSource;
export const WhiteLabelCustomDomainStatus = CoreEnums.WhiteLabelCustomDomainStatus;

export const MAIN_COLOR_PATTERN = /^#[0-9A-Fa-f]{6}$/;

/** Slot names match PUT branding attachment fields. */
export const ASSET_SLOTS = ['logo', 'iconLogo', 'favicon', 'font', 'loginSplash'];

export const IMAGE_ASSET_SLOTS = ['logo', 'iconLogo', 'favicon', 'loginSplash'];

export const ASSET_LABEL_IDS = {
  logo: 'whiteLabel.form.logo',
  iconLogo: 'whiteLabel.form.iconLogo',
  favicon: 'whiteLabel.form.favicon',
  font: 'whiteLabel.form.font',
  loginSplash: 'whiteLabel.form.loginSplash',
};

export const EFFECTIVE_ASSET_FIELDS = [
  { key: 'logo', labelId: ASSET_LABEL_IDS.logo, urlKey: 'logoUrl' },
  { key: 'iconLogo', labelId: ASSET_LABEL_IDS.iconLogo, urlKey: 'iconLogoUrl' },
  { key: 'favicon', labelId: ASSET_LABEL_IDS.favicon, urlKey: 'faviconUrl' },
  { key: 'loginSplash', labelId: ASSET_LABEL_IDS.loginSplash, urlKey: 'loginSplashUrl' },
];

export const BRANDING_FORM_FIELDS = [
  'isActive',
  'applyToChildren',
  'brandName',
  'mainColor',
  ...ASSET_SLOTS,
  'supportEmail',
];
